<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <sidebar
      :store-module-name="STORE_MODULE_NAME"
      :is-sidebar-active.sync="isSidebarActive"
      :show.sync="show"
      :data="sidebarData"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-1"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <span>{{ $t('Key') }} : </span>
              <v-select
                id="register-respDataKey"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="respDataKey"
                :reduce="respDataKey => respDataKey"
                :filterable="false"
                @search="onSearchKey"
                @input="selectedKey($event)"
              >
                <template
                  slot="option"
                  slot-scope="option"
                >
                  {{ option.value }}
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option"
                >
                  {{ option.value }}
                </template>
                <div
                  slot="list-footer"
                  class="m-1"
                >
                  <b-row>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        block
                        :disabled="currentPageKey <= 1 ? true : false"
                        @click="nextPageKey(currentPageKey - 1)"
                      >
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </b-button>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        block
                        disabled
                      >
                        {{ currentPageKey }}
                      </b-button>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        block
                        :disabled="
                          currentPageKey * perPageKey >= queriedItemsKey
                            ? true
                            : false
                        "
                        @click="nextPageKey(currentPageKey + 1)"
                      >
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </v-select>
            </b-col>
            <b-col
              v-for="(item, index) in language"
              :key="'a' + index"
              cols="6"
            >
              <!-- firstName -->
              <b-form-group
                v-if="langTranslate.length > 0"
                :label="$t(item.name)"
                :label-for="item.name"
              >
                <b-form-input
                  v-if="langTranslate[index]"
                  :id="item.name"
                  :disabled="true"
                  :name="item.name"
                  :value="langTranslate[index]['value']"
                  :placeholder="$t(item.name)"
                  @input="inputLanguage($event, item.lang, index)"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="langTranslate.length > 0"
              cols="12"
              class="text-center"
            >
              <span>{{ $t('Change To') }}</span>
            </b-col>
            <b-col
              v-for="(item, index) in language"
              :key="'b' + index"
              cols="6"
            >
              <!-- firstName -->
              <b-form-group
                v-if="dataLangTranslate.length > 0"
                :label="$t(item.name)"
                :label-for="item.name"
              >
                <b-form-input
                  v-if="dataLangTranslate[index]"
                  :id="item.name"
                  :name="item.name"
                  :value="dataLangTranslate[index]['value']"
                  :placeholder="$t(item.name)"
                  @input="inputDataLanguage($event, item.lang, index)"
                />
              </b-form-group>
            </b-col>
            <b-col
              v-if="dataLangTranslate.length > 0"
              cols="12"
            >
              <div class="d-flex mt-2 align-items-end justify-content-end">
                <b-button
                  variant="primary"
                  class="mr-2"
                  @click="addLanguage()"
                >
                  {{ $t('Save') }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="pageSize"
              />
              <label for="">{{ $t('entries') }}</label>
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="b-col-custom"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search') + '...'"
                  @input="typing($event)"
                />
                <!-- <div class="mb-2 mr-2">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="d-flex mr-1"
                    @click="updateJson()">
                    <span class="mr-25 align-middle">{{ $t("Update Json") }}</span>
                  </b-button>
                </div>
                <div v-if="nodeEnv !== 'production'" class="mb-2 mr-2">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" class="d-flex mr-1"
                    @click="updateToPublic()">
                    <span class="mr-25 align-middle">{{ $t("UPDATE_TO_PUBLIC") }}</span>
                  </b-button>
                </div>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="d-flex"
                  @click="sidebarAddNew()">
                  <feather-icon icon="PlusIcon" />
                </b-button> -->
                <!-- <b-form-file
                @change="importFileJson"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".json"
              /> -->
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          striped
          responsive
          class="position-relative"
          :items="respData"
          :fields="tableColumns"
          primary-key="_id"
          show-empty
          :empty-text="$t('No matching records found')"
          style="height: 60vh;"
        >
          <!-- Column: Images -->
          <template #cell(logo)="data">
            <b-row>
              <b-img
                v-if="data.item.logo"
                :src="data.item.logo"
                fluid
                thumbnail
                width="100px"
                :alt="'Users_' + data.item._id"
              />
              <b-img
                v-else
                :src="require('@/assets/images/blank/no_image.png')"
                fluid
                thumbnail
                width="100px"
                :alt="'Users_' + data.item._id"
              />
            </b-row>
          </template>
          <!-- Column: User -->
          <template #cell(langTranslate)="data">
            <p
              v-for="(item, index) in data.item.langTranslate"
              :key="index"
              class="align-middle ml-50"
            >
              {{ item.lang.toUpperCase() }}: {{ item.value }}
            </p>
          </template>
          <!-- Column: Action -->
          <template #cell(action)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="sidebarEdit(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t('Edit') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteData(data.item._id)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span
                class="text-muted"
              >{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t('of') }} {{ queriedItems }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="queriedItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="nextPage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BAvatar,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BDropdown,
  BOverlay,
  BDropdownItem,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/hero/servicesConfig'
import debounce from 'debounce'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Sidebar from './DataSidebar.vue'

const STORE_MODULE_NAME = 'servicesConfig'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    BFormInput,
    BButton,
    Sidebar,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BFormGroup,
    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      currentPage: 1,
      searchQuery: '',
      nodeEnv: 'production',
      perPage: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 30,
      isSidebarActive: false,
      sidebarData: {},
      show: false,
      perPageOptions,
      searchKey: '',
      currentPageKey: 1,
      perPageKey: 10,
      langTranslate: [],
      dataLangTranslate: [],
      value: '',
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'value', label: this.$t('Value'), sortable: false },
        {
          key: 'langTranslate',
          label: this.$t('langTranslate'),
          sortable: false,
        },
        { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.data
        : []
    },
    respDataKey() {
      return store.state[STORE_MODULE_NAME].respDataKey != null
        ? store.state[STORE_MODULE_NAME].respDataKey.data
        : []
    },
    queriedItemsKey() {
      return store.state[STORE_MODULE_NAME].respDataKey != null
        ? store.state[STORE_MODULE_NAME].respDataKey.max
        : 0
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.max
        : 0
    },
    language() {
      return store.state.appConfig.systemConfig
        ? store.state.appConfig.systemConfig.language
        : []
    },
    // eslint-disable-next-line vue/return-in-computed-property
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) {
      store.registerModule(STORE_MODULE_NAME, storeModule)
    }
    const obj = {
      currentPage: this.currentPage,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
    }
    const objKey = {
      currentPage: this.currentPageKey,
      pageSize: this.perPageKey,
      searchQuery: this.searchKey,
    }

    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/getLanguage`, obj)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        // eslint-disable-next-line no-unused-vars
      })
      .catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/getKey`, objKey)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        // eslint-disable-next-line no-unused-vars
      })
      .catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.typing = debounce(this.typing, 500)
    this.nodeEnv = process.env.NODE_ENV
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) {
      store.unregisterModule(STORE_MODULE_NAME)
    }
  },
  setup() {
    return { STORE_MODULE_NAME }
  },
  methods: {
    initValues() {
      this.value = ''
      this.langTranslate = []
      this.dataLangTranslate = []
    },
    addLanguage() {
      this.show = true
      const obj = {
        value: this.value,
        langTranslate: this.dataLangTranslate,
      }
      store
        .dispatch(`${STORE_MODULE_NAME}/addLanguage`, obj)
        .then(result => {
          this.show = false
          this.initValues()
          this.$emit('update:is-sidebar-active', false)
          console.log('fetch Success : ', result)
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        })
    },
    inputLanguage(input, lang, index) {
      if (this.langTranslate[index].lang === lang) {
        this.langTranslate[index].value = input
      }
    },
    inputDataLanguage(input, lang, index) {
      if (this.dataLangTranslate[index].lang === lang) {
        this.dataLangTranslate[index].value = input
      }
    },
    getKey(obj) {
      store
        .dispatch(`${STORE_MODULE_NAME}/getKey`, obj)
        .then(result => {
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPageKey(page) {
      this.currentPageKey = page
      const obj = {
        currentPage: this.currentPageKey,
        pageSize: this.perPageKey,
        searchQuery: this.searchKey,
      }
      this.getKey(obj)
    },
    onSearchKey(query) {
      this.searchKey = query
      this.currentPageKey = 1
      const obj = {
        currentPage: this.currentPageKey,
        pageSize: this.perPageKey,
        searchQuery: this.searchKey,
      }
      this.getKey(obj)
    },
    selectedKey(data) {
      this.value = data.value
      this.langTranslate = data.langTranslate
      if (this.dataLangTranslate.length !== this.language.length) {
        for (let index = 0; index < this.language.length; index += 1) {
          const indexLanguage = this.dataLangTranslate.findIndex(
            element => element.lang === this.language[index].lang,
          )
          if (indexLanguage < 0) {
            this.dataLangTranslate.push({
              lang: this.language[index].lang, // th , en
              value: '',
            })
          }
        }
      }
      if (this.langTranslate.length !== this.language.length) {
        for (let index = 0; index < this.language.length; index += 1) {
          const indexLanguage = this.langTranslate.findIndex(
            element => element.lang === this.language[index].lang,
          )
          if (indexLanguage < 0) {
            this.langTranslate.push({
              lang: this.language[index].lang, // th , en
              value: '',
            })
          }
        }
      }
    },
    updateJson() {
      store
        .dispatch(`${STORE_MODULE_NAME}/updateJson`, {
          servicesId: this.$route.params.id,
        })
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        })
    },
    updateToPublic() {
      store
        .dispatch(`${STORE_MODULE_NAME}/updateToPublicLanguage`, {
          id: this.$route.params.id,
          url: process.env.VUE_APP_API_SERVER,
        })
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    typing(value) {
      console.log(value)
      this.searchQuery = value
      const obj = {
        id: this.$route.params.id,
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/getLanguage`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    sidebarAddNew() {
      this.sidebarData = {}
      this.isSidebarActive = true
    },
    sidebarEdit(item) {
      this.sidebarData = item
      this.isSidebarActive = true
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/deleteLanguage`, id)
              .then(result => {
                this.show = false
                console.log('fetch Success : ', result)
              })
              .catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      const obj = {
        id: this.$route.params.id,
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/getLanguage`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPage(page) {
      this.currentPage = page
      const obj = {
        id: this.$route.params.id,
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/getLanguage`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.b-col-custom {
  margin-top: 0.5rem;
}
</style>
